import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import AuthService from '@/shared/services/AuthService';
import DataCacheService from '@/shared/services/DataCacheService';
import { ProfileQueryKey } from './queryKey';
export const useGetProfile = () => {
    var _a;
    const intl = useIntl();
    const isRealUser = !AuthService.isSupport();
    const { data, isLoading, refetch } = useQuery([ProfileQueryKey.Profile], () => api.base
        .get('/api/employee/profile')
        .then(res => res.data), {
        enabled: isRealUser,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    if (!isRealUser) {
        const employee = (_a = DataCacheService.getDataCache()) === null || _a === void 0 ? void 0 : _a.employee;
        return { data: employee, isLoading: false, refetch };
    }
    return { data, isLoading, refetch };
};
